export function getDisplayStatus(ticket: { status: string; assigned_to: string | null }): string {
  if (ticket.status === 'new' && ticket.assigned_to !== null) return 'pending';
  return ticket.status;
}
